import { render, staticRenderFns } from "./GridHistoricalFigures.vue?vue&type=template&id=2ee78bf8&"
import script from "./GridHistoricalFigures.vue?vue&type=script&lang=js&"
export * from "./GridHistoricalFigures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee78bf8')) {
      api.createRecord('2ee78bf8', component.options)
    } else {
      api.reload('2ee78bf8', component.options)
    }
    module.hot.accept("./GridHistoricalFigures.vue?vue&type=template&id=2ee78bf8&", function () {
      api.rerender('2ee78bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/historicalFigures/grid/GridHistoricalFigures.vue"
export default component.exports